import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {pathOr, isEmpty} from 'ramda'
import {Scrollbars} from 'react-custom-scrollbars-2'
import cn from 'classnames'
import URLSearchParams from 'url-search-params'
import _debounce from 'lodash.debounce'
import 'url-polyfill/url-polyfill.min'

import {PAGE_BF_FIRST_STEP} from '../../../../constants'
import HeaderSearch from '../../components/HeaderSearch'
import HeaderSearchEditable from '../../components/HeaderSearchEditable'
import Filters from '../Filters'
import SearchBar from '../../components/SearchBar'
import LatestSearch from '../../components/LatestSearch'
import Suggestions from '../../components/Suggestions'
import AirplaneIcon from '../../../icons/Airplane'
import AdagioIcon from '../../../icons/Adagio'
import HouseIcon from '../../../icons/House'
import GooglePlaceIcon from '../../../icons/GooglePlace'
import fetchLatestSearch from '../../actions/fetchLatestSearch'
import storeLatestSearch from '../../actions/storeLatestSearch'
import clearLatestSearch from '../../actions/clearLatestSearch'
import changeFilter from '../../actions/filters/filterChange'
import setPageIndex from '../../../searchResults/actions/setPageIndex'
import setHoldKeyword from '../../actions/setHoldKeyword'
import setSearchUrlHolder from '../../actions/setSearchUrlHolder'
import fetchCityHotels from '../../actions/fetchCityHotels'
import {
  ACTIVE_NONE,
  KEYWORD_SEARCH_LENGTH,
  SEARCH_PARAM_HOTEL_DIRECT_ID,
  DESTINATIONS_PAGE_VIEW,
  FILTER_DATES,
  TEMPORARY_SEARCH_PARAMETERS,
} from '../../constants'
import {hideBodyScroll, showBodyScroll} from '../../utils'
import {
  pushCloseSearch,
  pushSearchClick,
  pushSearchBarInteract,
  pushSearchNavigationClick
} from '../../../../helpers/gtm'
import offersMockedData, {hotelTitle, destinationsSearchPlaceholder} from '../../helpers/drupalSettings'
import {isDesktop} from '../../../../helpers/browser'
import syncFilters from '../../../shared/actions/syncFilters'
import codeApply from '../../actions/filters/professionalCode'
import codeChange from '../../actions/filters/codeChange'
import {mergeSearchParams} from '../../../../helpers/urlHelpers';

import './search-box.scss'

const STATE_LATEST_SEARCH = 'latestSearch'
const STATE_CITY_HOTELS = 'cityHotels'
const STATE_GEO_PLACES = 'geoPlaces'
const HOTEL_SOURCE = 'hod_hotels'
const GEO_SOURCE = 'geomaj'

const initialState = {
  showHeaderSearch: true,
  showSearchBox: false,
  keyword: '',
  [STATE_LATEST_SEARCH]: {
    items: [],
    loading: false,
    loaded: false,
    error: null,
  },
  [STATE_CITY_HOTELS]: {
    items: [],
    loading: false,
    loaded: false,
    error: null,
  },
  [STATE_GEO_PLACES]: {
    items: [],
    loading: false,
    loaded: false,
    error: null,
  },
  offers: offersMockedData.list,
  isDestinationsPage: false,
}

class SearchBox extends Component {
  static propTypes = {
    searchBoxData: PropTypes.shape({
      titles: PropTypes.shape({
        wantToLiveIn: PropTypes.string.isRequired,
        edit: PropTypes.string.isRequired,
        searchButtonValue: PropTypes.string.isRequired,
        yourLatestSearch: PropTypes.string.isRequired,
        ourBestDestinations: PropTypes.string.isRequired,
        ourAparthotelIn: PropTypes.string.isRequired,
        // filters: Filters.propTypes.titles, This propTypes.titles missed in Filters component. Need check and fix to the correct one.
      }),
      destinations: Suggestions.propTypes.items,
      api: PropTypes.shape({
        getLatest: PropTypes.string.isRequired,
        clearLatest: PropTypes.string.isRequired,
        storeLatest: PropTypes.string.isRequired,
        getAutocomplete: PropTypes.string.isRequired,
      }),
      searchResultsUrl: PropTypes.string.isRequired,
    }).isRequired,
    filtersData: PropTypes.objectOf(PropTypes.any),
    filtersTypes: PropTypes.arrayOf(PropTypes.string),
    activeFilter: PropTypes.string,
    pageIndex: PropTypes.number.isRequired,

    searchResultsKeyword: PropTypes.string.isRequired,
    openFilter: PropTypes.string.isRequired,
    filterChangeAction: PropTypes.func.isRequired,
    setPageIndexAction: PropTypes.func.isRequired,
    isOffers: PropTypes.bool.isRequired,
    browser: PropTypes.objectOf(Object).isRequired,
    isDatesApplied: PropTypes.bool,
    holdKeyword: PropTypes.string,
    searchUrlHolder: PropTypes.string,
    searchUrlFilterHolder: PropTypes.string,
    code: PropTypes.objectOf(Object),
    codeApply: PropTypes.bool,
    searchFilters: PropTypes.objectOf(Object),
    pageView: PropTypes.string,
  }

  static defaultProps = {
    filtersData: {},
    filtersTypes: undefined,
    activeFilter: undefined,
    isDatesApplied: false,
    holdKeyword: '',
    searchUrlHolder: '',
    searchUrlFilterHolder: '',
    code: {},
    codeApply: false,
    searchFilters: {},
    pageView: '',
  }

  state = initialState

  componentWillMount() {
    const {pageIndex, setPageIndexAction} = this.props
    setPageIndexAction(pageIndex)
    if (this.showFilters()) {
      ['search-results'].forEach(result => document.querySelector('.site-header').classList.add(result))
    }
  }

  componentDidMount() {
    const {
      filterChangeAction,
      pageView,
      browser,
      syncFiltersAction,
      setHoldKeyword,
    } = this.props
    syncFiltersAction()
    this.actionFetchLatestSearch()
    window.addEventListener('mousedown', this.handleClickOutside)
    document.body.classList.add('old-searchbox')

    if (pageView === DESTINATIONS_PAGE_VIEW && isDesktop(browser)) {
      filterChangeAction('activeFilter', FILTER_DATES)
    }

    // console.log('test', destinationsSearchPlaceholder)
    if (destinationsSearchPlaceholder) {
      setHoldKeyword(destinationsSearchPlaceholder)
    }
  }

  componentWillUnmount() {
    window.removeEventListener('mousedown', this.handleClickOutside)
  }

  setInner = (elem) => {
    this.inner = elem
  }

  getKeyword = () => {
    const {keyword} = this.state
    return keyword
  }

  actionFetchLatestSearch = async () => {
    const {
      searchBoxData: {api: {getLatest: latestSearchUrl}},
    } = this.props

    this.requestToState(STATE_LATEST_SEARCH, [], true, false)

    try {
      this.requestToState(
        STATE_LATEST_SEARCH,
        await fetchLatestSearch(latestSearchUrl),
        false,
        true,
      )
    } catch (e) {
      this.requestToState(STATE_LATEST_SEARCH, [], false, true, e.message)
    }
  }

  actionStoreLatestSearch = async (keyword, source = false, type = false, id = false) => {
    this.requestToState(STATE_LATEST_SEARCH, [], true, false)
    try {
      this.requestToState(
        STATE_LATEST_SEARCH,
        await storeLatestSearch(keyword, source, type, id),
        false,
        true,
      )
    } catch (e) {
      this.requestToState(STATE_LATEST_SEARCH, [], false, true, e.message)
    }
  }

  debouncedFetchCityRequest = _debounce(async (keyword) => {
    const {
      searchBoxData: {api: {getAutocomplete: getAutocompleteUrl}},
    } = this.props

    try {
      const items = pathOr([], ['data', 'predictions'], await fetchCityHotels(getAutocompleteUrl, keyword), false, true)
      const hotels = []
      const geo = []
      items.forEach((item) => {
        if (item.source === HOTEL_SOURCE) {
          hotels.push({ name: item.description, id: item.id, source: item.source})
        } else if (item.source === GEO_SOURCE) {
          geo.push({
            name: item.description, id: item.id, type: item.type, source: item.source,
          })
        }
      })
      this.requestToState(STATE_CITY_HOTELS, hotels, false, true)
      this.requestToState(STATE_GEO_PLACES, geo, false, true)
    } catch (e) {
      this.requestToState(STATE_CITY_HOTELS, [], false, true, e.message)
    }
  }, 300)

  actionFetchCityHotels = async (keyword) => {
    this.requestToState(STATE_CITY_HOTELS, [], true, false)
    await this.debouncedFetchCityRequest(keyword)
  }

  requestToState = (requestName, items, loading, loaded, error = null) => (
    this.setState({
      [requestName]: {
        items,
        loading,
        loaded,
        error,
      },
    })
  )

  handleCloseBar = () => {
    const {showSearchBox, [STATE_LATEST_SEARCH]: latestSearch} = this.state

    if (showSearchBox) {
      this.setState({
        ...initialState,
        [STATE_LATEST_SEARCH]: latestSearch,
      })
    }
    showBodyScroll(true)

    pushCloseSearch()
    pushSearchBarInteract({
      label: 'destination',
      action: 'close'
    })
  }

  handleClickOutside = (event) => {
    event.stopPropagation()
    const {showSearchBox} = this.state
    if (showSearchBox && this.inner && !this.inner.contains(event.target)) {
      this.handleCloseBar()
    }
  }

  clearSearchParams = (url, params) => {
    params.forEach((param) => {
      url.searchParams.delete(param)
    })

    return url
  }

  /**
   * Redirect to search page with query.
   */
  storeSearch = (
    keyword, source = false, type = false, id = false, isOfferBanner = false, title,
  ) => {
    const {
      searchBoxData: {
        searchResultsUrl,
      },
      isOffers,
      queryString,
    } = this.props
    const searchQueryParamsKey = [
      'geoType', 'geoCode', 'offerBanner', 'TK', SEARCH_PARAM_HOTEL_DIRECT_ID, 'offerCity', 'isAutocomplete', 'q',
    ]

    pushSearchBarInteract({
      action: 'modify',
      label: 'destination',
    })

    const text = keyword.trim()
    // Save search to cookies.
    this.actionStoreLatestSearch(text, source, type, id)
    // Get Url of search result page.
    let url = new URL(searchResultsUrl === `${window.location.origin}${window.location.pathname}` ? window.location.href : searchResultsUrl)
    const params = new URLSearchParams(queryString)

    url = mergeSearchParams(url, params)
    url = this.clearSearchParams(url, searchQueryParamsKey)

    if (title) {
      if (isOffers) url.searchParams.set('offerCity', title)
    } else {
      url.searchParams.delete('offerCity')
    }

    url.searchParams.set('q', text)
    url.searchParams.set('isAutocomplete', true)

    if (source === HOTEL_SOURCE) {
      // Search hotel.
      url.searchParams.append(SEARCH_PARAM_HOTEL_DIRECT_ID, id)
    } else if (source === GEO_SOURCE) {
      // Search region.
      url.searchParams.append('geoCode', id)
      url.searchParams.append('geoType', type)
    } else if (isOffers) {
      url.searchParams.set(isOfferBanner ? 'offerBanner' : 'TK', offersMockedData.TK)
    }

    this.setState({
      showHeaderSearch: true,
      showSearchBox: false,
    })

    pushSearchNavigationClick()
    window.location = url
  }

  storeSearchDesktopSearchBox = (
    keyword, source = false, type = false, id = false, isOfferBanner = false, title,
  ) => {
    const {
      searchBoxData: {
        searchResultsUrl,
      },
      isOffers,
      setHoldKeyword,
      setSearchUrlHolder,
      queryString,
    } = this.props
    const text = keyword.trim()
    // Save search to cookies.
    this.actionStoreLatestSearch(text, source, type, id)
    // Get Url of search result page.
    let url = new URL(searchResultsUrl === `${window.location.origin}${window.location.pathname}` ? window.location.href : searchResultsUrl)

    url = this.clearSearchParams(url, [
      'geoType', 'geoCode', 'offerBanner', 'TK', SEARCH_PARAM_HOTEL_DIRECT_ID, 'offerCity', ...TEMPORARY_SEARCH_PARAMETERS
    ])

    if (title) {
      if (isOffers) {
        url.searchParams.set('offerCity', title)
      }
    } else {
      url.searchParams.delete('offerCity')
    }

    url.searchParams.set('q', text)
    url.searchParams.set('isAutocomplete', true)

    if (source === HOTEL_SOURCE) {
      // Search hotel.
      url.searchParams.append(SEARCH_PARAM_HOTEL_DIRECT_ID, id)
    } else if (source === GEO_SOURCE) {
      // Search region.
      url.searchParams.append('geoCode', id)
      url.searchParams.append('geoType', type)
    } else if (isOffers) {
      url.searchParams.set(isOfferBanner ? 'offerBanner' : 'TK', offersMockedData.TK)
    }

    setHoldKeyword(title || text)
    setSearchUrlHolder(url)
    const location = url.search
    const params = new URLSearchParams(queryString)
    params.delete('offerCity')
    params.delete('q')
    params.delete('isAutocomplete')
    params.delete('TK')
    const pushUrl = `${location }&${params.toString()}`
    window.history.replaceState({}, '', pushUrl)
  }

  handleHeaderSearchClick = (event) => {
    event.preventDefault()
    event.stopPropagation()
    const {
      filterChangeAction,
    } = this.props

    this.setState({
      showHeaderSearch: false,
      showSearchBox: true,
    })
    pushSearchBarInteract({
      action: 'open',
      label: 'destination',
    })

    /**
     * Close filter popUp if one is open
     */
    const {openFilter} = this.props
    if (openFilter !== ACTIVE_NONE) {
      filterChangeAction('activeFilter', ACTIVE_NONE)
    }
    /**
     * For the case when Filters dialog
     * was not closed before we clicked on the Search Header
     */
    showBodyScroll(false)
    hideBodyScroll(true)
  }

  handleClearLatestSearch = async () => {
    const {
      searchBoxData: {api: {clearLatest: clearLatestUrl}},
    } = this.props

    this.requestToState(STATE_LATEST_SEARCH, [], true, false)

    try {
      this.requestToState(STATE_LATEST_SEARCH, await clearLatestSearch(clearLatestUrl), false, true)
    } catch (e) {
      this.requestToState(STATE_LATEST_SEARCH, [], false, true, e.message)
    }
  }

  handleSearchInput = (event) => {
    const {isOffers} = this.props
    const keyword = event.target.value
    this.setState({
      keyword,
    })

    if (keyword.length >= KEYWORD_SEARCH_LENGTH) {
      if (isOffers) {
        const inpVal = keyword.trim()
        const newOffers = []

        offersMockedData.list.forEach((cityObj) => {
          const hotels = Object.keys(cityObj.hotels)
            .map(key => ({...cityObj.hotels[key]}))
            .filter(hotel => hotel.title.toUpperCase().indexOf(inpVal.toUpperCase()) >= 0)

          if (cityObj.city.toUpperCase().indexOf(inpVal.toUpperCase()) >= 0) {
            newOffers.push({...cityObj})
          } else if (hotels.length) {
            newOffers.push({
              ...cityObj,
              hotels: {...hotels},
            })
          }
        })
        this.setState({offers: newOffers})
      }
      this.actionFetchCityHotels(keyword)
    } else if (isOffers) {
      this.setState({offers: offersMockedData.list})
    }
  }

  handleSearchKeyPress = (event) => {
    const {keyword} = this.state
    const {
      isOffers,
    } = this.props
    const text = keyword.trim()
    if (event.key === 'Enter' && text.length > 2) {
      pushSearchClick()
      this.storeSearch(text, false, false, false, isOffers)
    }
  }

  keywordLength = () => this.getKeyword().length

  showLatestSearch = () => {
    const {[STATE_LATEST_SEARCH]: latestSearch} = this.state
    return (Array.isArray(latestSearch.items)
        && latestSearch.items.length > 0
        && this.showDestinations()
      )
      || latestSearch.loading
  }

  showDestinations = () => this.keywordLength() < KEYWORD_SEARCH_LENGTH

  showElement = element => (this.keywordLength() >= KEYWORD_SEARCH_LENGTH
      && element.items.length > 0)
    || element.loading

  showFilters = () => {
    const {filtersTypes} = this.props
    return Array.isArray(filtersTypes) && filtersTypes.length > 0
  }

  handleSearchInputDesktop = (event) => {
    const { isOffers } = this.props
    const keyword = event.target.value
    const text = keyword.trim()
    this.setState({
      keyword,
    })
    if (keyword.length >= KEYWORD_SEARCH_LENGTH) {
      if (isOffers) {
        const inpVal = keyword.trim()
        const newOffers = []

        offersMockedData.list.forEach((cityObj) => {
          const hotels = Object.keys(cityObj.hotels)
            .map(key => ({ ...cityObj.hotels[key] }))
            .filter(hotel => hotel.title.toUpperCase().indexOf(inpVal.toUpperCase()) >= 0)

          if (cityObj.city.toUpperCase().indexOf(inpVal.toUpperCase()) >= 0) {
            newOffers.push({ ...cityObj })
          } else if (hotels.length) {
            newOffers.push({
              ...cityObj,
              hotels: { ...hotels },
            })
          }
        })

        this.setState({ offers: newOffers })
      }
      this.actionFetchCityHotels(keyword)
    } else if (isOffers) {
      this.setState({ offers: offersMockedData.list })
    }
    this.storeSearchDesktopSearchBox(text, false, false, false, isOffers)
  }

  handleDesktopHeaderSearchSubmitClick = async (event) => {
    event.preventDefault()
    event.stopPropagation()
    const {
      browser,
      filterChangeAction,
      searchResultsUrl,
    } = this.props

    if (isDesktop(browser)) {
      window.location = `${searchResultsUrl}/${window.location.search}`
      this.setState({
        showSearchBox: false,
      })
    }

    /**
     * Close filter popUp if one is open
     */
    const { openFilter } = this.props
    if (openFilter !== ACTIVE_NONE) {
      filterChangeAction('activeFilter', ACTIVE_NONE)
    }
    /**
     * For the case when Filters dialog
     * was not closed before we clicked on the Search Header
     */
    showBodyScroll(false)
    hideBodyScroll(true)
  }

  renderHeaderSearch = () => {
    const {
      searchBoxData: {
        titles,
      },
      searchResultsKeyword,
      pageIndex,
      pageView,
    } = this.props

    switch (pageIndex) {
      case PAGE_BF_FIRST_STEP:
        return (
          <HeaderSearchEditable
            onClick={this.handleHeaderSearchClick}
            keyword={
              hotelTitle && hotelTitle.length ? hotelTitle : searchResultsKeyword
            }
            editLabel={titles.edit}
          />
        )
      default:
        return (
          <HeaderSearch
            placeholder={destinationsSearchPlaceholder || titles.wantToLiveIn}
            searchButtonValue={titles.searchButtonValue}
            onClick={this.handleHeaderSearchClick}
            showFilters={this.showFilters()}
            pageView={pageView}
            clearSearch={titles.clear}
            keyword={
              hotelTitle && hotelTitle.length ? hotelTitle : searchResultsKeyword
            }
          />
        )
    }
  }

  render() {
    const {
      searchBoxData: {
        titles,
        destinations: destinationItems,
      },
      filtersData,
      filtersTypes,
      activeFilter,
      isOffers,
      browser,
      searchResultsKeyword,
    } = this.props
    const {
      showHeaderSearch,
      showSearchBox,
      [STATE_LATEST_SEARCH]: {items: latestSearchItems},
      [STATE_LATEST_SEARCH]: latestSearch,
      [STATE_GEO_PLACES]: geoPlaces,
      [STATE_CITY_HOTELS]: cityHotels,
      offers,
    } = this.state
    const URLParams = new URLSearchParams(window.location.search)

    return (
      <div className="search-box-app">
      {
        this.showFilters() ? (
          // Search with filters
          <React.Fragment>
            {showHeaderSearch && this.renderHeaderSearch()}

            {showSearchBox && (
              <div className={cn('search-box', {isOffers})} ref={this.setInner}>
                <SearchBar
                  title={titles.wantToLiveIn}
                  onCloseBar={this.handleCloseBar}
                  onChange={this.handleSearchInput}
                  onKeyPress={this.handleSearchKeyPress}
                />
                <div className="search-box__container">
                  {isOffers && offersMockedData && !!offersMockedData.label && (
                    <span className="search-box__offers-label">
                      {offersMockedData.label}
                    </span>
                  )}
                  <Scrollbars
                    renderThumbVertical={({style, ...props}) => (
                      <div
                        {...props}
                        style={{
                          ...style,
                          backgroundColor: '#40e9c4',
                          width: '4px',
                          opacity: '0.8',
                          borderRadius: '2px',
                          marginLeft: '2px',
                        }}
                      />
                    )}
                    className="search-box__scroll"
                    autoHeight
                    autoHeightMax={450}
                  >
                    { isOffers && offersMockedData.label &&
                      <div className="suggestions-header__title">
                        {offersMockedData.label}
                      </div>
                    }

                    {isOffers && offers.map((cityObj, i) => (
                      <Suggestions
                        key={`${cityObj.city}_${i + 1}`}
                        title={cityObj.city}
                        titleEn={cityObj.titleEn}
                        TitleIcon={cityObj.icon}
                        hotels={cityObj.hotels}
                        onChooseKeyword={this.storeSearch}
                        isOffers
                      />
                    ))}
                    <React.Fragment>
                      {this.showLatestSearch(latestSearchItems) && (
                          <LatestSearch
                              title={titles.yourLatestSearch}
                              data={latestSearch}
                              clearLatestText={titles.clear}
                              onClearLatest={this.handleClearLatestSearch}
                              onChooseKeyword={this.storeSearch}
                          />
                      )}
                      {this.showElement(geoPlaces) && (
                          <Suggestions
                              ItemIcon={GooglePlaceIcon}
                              data={geoPlaces}
                              onChooseKeyword={this.storeSearch}
                              className="google-places"
                          />
                      )}
                      {this.showDestinations() && (
                          <Suggestions
                              TitleIcon={AirplaneIcon}
                              title={titles.ourBestDestinations}
                              data={{items: destinationItems}}
                              onChooseKeyword={this.storeSearch}
                          />
                      )}
                      {this.showElement(cityHotels) && (
                          <Suggestions
                              TitleIcon={AdagioIcon}
                              title={titles.ourAparthotelIn}
                              ItemIcon={HouseIcon}
                              data={cityHotels}
                              onChooseKeyword={this.storeSearch}
                          />
                      )}
                    </React.Fragment>
                  </Scrollbars>
                </div>
              </div>
            )}

            <Filters
              data={filtersData}
              types={filtersTypes}
              activeByDefault={activeFilter || URLParams.get('active_filter')}
            />
          </React.Fragment>

        ) : (
          // Simple search
          <div className={'header-search__simple-wrapper'}>
            {isDesktop(browser) ? (
              // Desktop
              <React.Fragment>
                <HeaderSearch
                  placeholder={destinationsSearchPlaceholder || titles.wantToLiveIn}
                  searchButtonValue={titles.searchButtonValue}
                  onClick={this.handleHeaderSearchClick}
                  onDesktopSubmit={this.handleDesktopHeaderSearchSubmitClick}
                  showFilters={this.showFilters()}
                  clearSearch={titles.clear}
                  onChange={this.handleSearchInputDesktop}
                  onKeyPress={this.handleSearchKeyPress}
                  keyword={
                    hotelTitle?.length ? hotelTitle : searchResultsKeyword
                  }
                />
              {showSearchBox && (
                <div className={cn('search-box search-box_simple', {isOffers})} ref={this.setInner}>
                  <div className="search-box__container">
                    {isOffers && offersMockedData && !!offersMockedData.label && (
                      <span className="search-box__offers-label">
                  {offersMockedData.label}
                </span>
                    )}
                    <Scrollbars
                      renderThumbVertical={({style, ...props}) => (
                        <div
                          {...props}
                          style={{
                            ...style,
                            backgroundColor: '#000',
                            width: '4px',
                            opacity: '0.8',
                            borderRadius: '2px',
                            marginLeft: '2px',
                          }}
                        />
                      )}
                      className="search-box__scroll"
                      autoHeight
                      autoHeightMax={450}
                    >
                      {isOffers && offers.map((cityObj, i) => (
                        <Suggestions
                          key={`${cityObj.city}_${i + 1}`}
                          title={cityObj.city}
                          titleEn={cityObj.titleEn}
                          TitleIcon={cityObj.icon}
                          hotels={cityObj.hotels}
                          onChooseKeyword={this.storeSearch}
                          isOffers
                        />
                      ))}
                      <React.Fragment>
                        {this.showLatestSearch(latestSearchItems) && (
                          <LatestSearch
                            title={titles.yourLatestSearch}
                            data={latestSearch}
                            clearLatestText={titles.clear}
                            onClearLatest={this.handleClearLatestSearch}
                            onChooseKeyword={this.storeSearch}
                          />
                        )}
                        {this.showElement(geoPlaces) && (
                          <Suggestions
                            ItemIcon={GooglePlaceIcon}
                            data={geoPlaces}
                            onChooseKeyword={this.storeSearch}
                            className="google-places"
                          />
                        )}
                        {this.showDestinations() && (
                          <Suggestions
                            TitleIcon={AirplaneIcon}
                            title={titles.ourBestDestinations}
                            data={{items: destinationItems}}
                            onChooseKeyword={this.storeSearch}
                          />
                        )}
                        {this.showElement(cityHotels) && (
                          <Suggestions
                            TitleIcon={AdagioIcon}
                            title={titles.ourAparthotelIn}
                            ItemIcon={HouseIcon}
                            data={cityHotels}
                            onChooseKeyword={this.storeSearch}
                          />
                        )}
                      </React.Fragment>
                    </Scrollbars>
                  </div>
                </div>
              )}
              </React.Fragment>
              ) : (
              // Mobile
              <React.Fragment>
                { this.renderHeaderSearch()}
                {showSearchBox && (
                  <div className={cn('search-box search-box_simple', {isOffers})} ref={this.setInner}>
                    <SearchBar
                      title={titles.wantToLiveIn}
                      onCloseBar={this.handleCloseBar}
                      onChange={this.handleSearchInput}
                      onKeyPress={this.handleSearchKeyPress}
                    />
                    <div className="search-box__container">
                      {isOffers && offersMockedData && !!offersMockedData.label && (
                        <span className="search-box__offers-label">
                  {offersMockedData.label}
                </span>
                      )}
                      <Scrollbars
                        renderThumbVertical={({style, ...props}) => (
                          <div
                            {...props}
                            style={{
                              ...style,
                              backgroundColor: '#40e9c4',
                              width: '4px',
                              opacity: '0.8',
                              borderRadius: '2px',
                              marginLeft: '2px',
                            }}
                          />
                        )}
                        className="search-box__scroll"
                        autoHeight
                        autoHeightMax={450}
                      >
                        {isOffers && offers.map((cityObj, i) => (
                          <Suggestions
                            key={`${cityObj.city}_${i + 1}`}
                            title={cityObj.city}
                            titleEn={cityObj.titleEn}
                            TitleIcon={cityObj.icon}
                            hotels={cityObj.hotels}
                            onChooseKeyword={this.storeSearch}
                            isOffers
                          />
                        ))}
                        <React.Fragment>
                          {this.showLatestSearch(latestSearchItems) && (
                            <LatestSearch
                              title={titles.yourLatestSearch}
                              data={latestSearch}
                              clearLatestText={titles.clear}
                              onClearLatest={this.handleClearLatestSearch}
                              onChooseKeyword={this.storeSearch}
                            />
                          )}
                          {this.showElement(geoPlaces) && (
                            <Suggestions
                              ItemIcon={GooglePlaceIcon}
                              data={geoPlaces}
                              onChooseKeyword={this.storeSearch}
                              className="google-places"
                            />
                          )}
                          {this.showDestinations() && (
                            <Suggestions
                              TitleIcon={AirplaneIcon}
                              title={titles.ourBestDestinations}
                              data={{items: destinationItems}}
                              onChooseKeyword={this.storeSearch}
                            />
                          )}
                          {this.showElement(cityHotels) && (
                            <Suggestions
                              TitleIcon={AdagioIcon}
                              title={titles.ourAparthotelIn}
                              ItemIcon={HouseIcon}
                              data={cityHotels}
                              onChooseKeyword={this.storeSearch}
                            />
                          )}
                        </React.Fragment>
                      </Scrollbars>
                    </div>
                  </div>
                )}
              </React.Fragment>
              )
            }
          </div>
        )
      }
      </div>
    )
  }
}

const mapStateToProps = ({
  main: {
    searchResultsKeyword,
    searchUrlHolder,
    searchUrlFiltersHolder,
    queryString,
    holdKeyword,
    setting: {
      pageView,
      widgets: {
        searchBox: {
          searchResultsUrl,
        },
      },
    },
  },
  form: {
    searchFilters: {
      activeFilter,
      datesApply,
      code,
      codeApply,
    },
  },
  browser,
}) => ({
  holdKeyword,
  searchUrlHolder,
  searchUrlFiltersHolder,
  searchResultsKeyword,
  searchResultsUrl,
  openFilter: activeFilter,
  isOffers: offersMockedData && !isEmpty(offersMockedData) && !isEmpty(offersMockedData.list),
  browser,
  isDatesApplied: datesApply,
  code,
  codeApply,
  pageView,
  queryString,
})

const mapDispatchToProps = {
  filterChangeAction: changeFilter,
  setPageIndexAction: setPageIndex,
  syncFiltersAction: syncFilters,
  setHoldKeyword,
  setSearchUrlHolder,
  codeApplyAction: codeApply,
  codeChangeAction: codeChange,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SearchBox)
